var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-info"},[_c('p',[_vm._v("The settings for this viewer were deleted by their creator.")]),_c('a',{staticClass:"btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.close.apply(null, arguments)}}},[_vm._v("Continue to default settings")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }